"use strict";
/**
 * @name ProgressBar
 *
 * @description
 *  A progress bar component that will render the appropriate styles for displaying progress by a width percent.  See
 *  the teamsnap patterns library for more information https://teamsnap-ui-patterns.netlify.com/patterns/components/progress-bar.html
 *
 * @example
 * <ProgressBar
 *   title='Percentage Paid'
 *   type='negative'
 *   size='small'
 *   width='40%' />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_spring_1 = require("react-spring");
var helpers_1 = require("../../utils/helpers");
var easing_1 = require("../../utils/easing");
var propTypes = {
    animate: PropTypes.bool.isRequired,
    progress: PropTypes.number.isRequired,
    size: PropTypes.string,
    color: PropTypes.string,
    isPrecise: PropTypes.bool.isRequired,
    isVertical: PropTypes.bool.isRequired,
    isSquared: PropTypes.bool.isRequired,
    className: PropTypes.string.isRequired,
    mods: PropTypes.string,
    style: PropTypes.object.isRequired,
    testId: PropTypes.string,
    otherProps: PropTypes.object.isRequired,
};
var ProgressBar = function (_a) {
    var _b, _c;
    var animate = _a.animate, progress = _a.progress, color = _a.color, size = _a.size, isVertical = _a.isVertical, isPrecise = _a.isPrecise, isSquared = _a.isSquared, className = _a.className, mods = _a.mods, style = _a.style, testId = _a.testId, otherProps = _a.otherProps;
    var springConfig = {
        from: {
            width: '0%',
        },
        to: {
            width: progress + "%",
        },
        delay: 200,
        config: {
            duration: 800,
            easing: easing_1.Easing.easeInOut,
        },
    };
    var animation = (0, react_spring_1.useSpring)(springConfig);
    var progressClasses = (0, helpers_1.getClassName)(className, size && "ProgressBar--" + size, color && "ProgressBar--" + color, isVertical && 'ProgressBar--vertical', isPrecise && 'ProgressBar--precise', isSquared && 'ProgressBar--squared', mods);
    var propertyKey = isVertical ? 'height' : 'width';
    return (React.createElement("div", __assign({ className: progressClasses, style: style, "data-testid": testId }, otherProps), animate ? (React.createElement(react_spring_1.animated.div, { className: "ProgressBar-status", style: (_b = {}, _b[propertyKey] = animation.width, _b) })) : (React.createElement("div", { className: "ProgressBar-status", style: (_c = {}, _c[propertyKey] = progress + "%", _c) }))));
};
ProgressBar.defaultProps = {
    animate: false,
    progress: 0,
    isPrecise: false,
    isVertical: false,
    isSquared: false,
    className: 'ProgressBar',
    style: {},
    otherProps: {},
};
exports.default = ProgressBar;
